@for (toast of toastr.toasts(); track toast) {
    <ngb-toast
        [class]="getClassname(toast)"
        [autohide]="!toast.disableTimeout"
        [delay]="toast.timeoutMs || 9000"
        (hidden)="toastr.remove(toast)"
    >
        <div class="d-flex align-items-start gap-3">
            <div class="flex-grow-1 align-self-center">
                @if (toast.title){
                  <h1 class="fs-16 fw-bold mb-1">
                    <span [outerHTML]="toast.title"></span>
                  </h1>
                }
                @if (toast.message){
                  <div>
                    <span [outerHTML]="toast.message"></span>
                  </div>
                }
            </div>
            <div>
                <button class="btn p-1 border-0" (click)="toastr.remove(toast)">
                    <iconify classNames="icon" name="iconoir:cancel" [size]="21" />
                </button>
            </div>
        </div>
    </ngb-toast>
}
